<template>
    <div class="questionzb">
        <van-nav-bar :title="$route.query.name" @click-left="onClickLeft" left-arrow />
        <van-cell-group style="margin-bottom: 10px;">
            <van-cell title="关联文件：">
                <template #default>
                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                        {{ info.ywprojectfile != null ? info.ywprojectfile.fname : '关联文件已被删除' }}
                    </div>
                </template>
            </van-cell>
            <van-cell title="清单状态：">
                <template #default>
                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                        {{ info.strstatus }}
                    </div>
                </template>
            </van-cell>
            <div v-for="(item, index) in   info.disposelsit  " :key="index">
                <van-cell :title="index == 0 ? '发起人：' : '追问人：'">
                    <template #default>
                        <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                            {{ item.fbusername }}
                        </div>
                    </template>
                </van-cell>
                <van-cell :title="index == 0 ? '发起时间：' : '追问时间：'">
                    <template #default>
                        <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                            {{ item.fbdate }}
                        </div>
                    </template>
                </van-cell>
                <van-cell title="反馈内容：">
                    <template #label>
                        <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                            <ckediter4 v-model="item.fbcontent" :disable="true"></ckediter4>
                        </div>
                    </template>
                </van-cell>
                <van-cell-group style="margin-bottom: 10px;" v-if="info.creatuser == uid && replyUserAuthority">
                    <van-cell title="回复人：" v-if="item.disposecontent != null">
                        <template #default>
                            <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                {{ item.disusername }}
                            </div>
                        </template>
                    </van-cell>
                    <van-cell title="回复时间：" v-if="item.disposecontent != null">
                        <template #default>
                            <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                            </div>
                        </template>
                    </van-cell>
                    <van-cell title="回复内容：">
                        <template #label>
                            <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                <ckediter4 ref="ck" v-model="item.disposecontent"
                                    :disable="item.disposecontent != null ? true : false"></ckediter4>
                            </div>
                        </template>
                    </van-cell>
                    <div style="width: 90%; margin: 20px auto" v-if="item.disusername == null && index + 1 == info.disposelsit.length
                        ">
                        <van-button type="info" style="width: 100%; margin: auto" round
                            @click="questionBtn(item, false, index)">确定</van-button>
                    </div>
                    <div v-else>
                        <div style="width: 90%; margin: 20px auto;display: flex;" v-if="index + 1 == info.disposelsit.length
                            ">
                            <van-button type="default" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                                @click="continueBtn()">继续追问</van-button>
                            <van-button type="info" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                                @click="questionBtn(item, true, index)">关闭问题</van-button>
                        </div>
                    </div>

                </van-cell-group>
                <van-cell-group v-else>
                    <div
                        v-if="!(index + 1 == info.disposelsit.length && (replyUserAuthority) == false) || item.disposecontent != null">
                        <div>
                            <van-cell title="回复人：">
                                <template #default>
                                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                        {{ item.disusername }}
                                    </div>
                                </template>
                            </van-cell>
                            <van-cell title="回复时间：">
                                <template #default>
                                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                        {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                    </div>
                                </template>
                            </van-cell>
                            <van-cell title="回复内容：">
                                <template #label>
                                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                        <ckediter4 ref="ck" v-model="item.disposecontent"
                                            :disable="item.disposecontent != null ? true : questionDisable"></ckediter4>
                                    </div>
                                </template>
                            </van-cell>
                        </div>

                        <div v-if="info.creatuser == uid && index + 1 == info.disposelsit.length"
                            style="width: 90%; margin: 20px auto;display: flex;">
                            <van-button type="default" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                                @click="continueBtn()">继续追问</van-button>
                            <van-button type="info" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                                @click="questionBtn(item, true, index)">关闭问题</van-button>
                        </div>
                        <div v-else>
                            <div style="width: 90%; margin: 20px auto" v-if="item.disusername == null && index + 1 == info.disposelsit.length
                                ">
                                <van-button type="info" style="width: 100%; margin: auto" round
                                    @click="questionBtn(item, false, index)">确定</van-button>
                            </div>
                        </div>
                    </div>
                </van-cell-group>
            </div>
            <div v-if="zwStatus == false">
                <van-cell title="追问：">
                    <template #label>
                        <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                            <ckediter4 ref="ck2" v-model="newFeedback.disposecontent" :disable="zwStatus"></ckediter4>
                        </div>
                    </template>
                </van-cell>
                <van-button type="info" style="width: 100%; margin: auto" round @click="questionBtn1()">确定追问</van-button>
            </div>
        </van-cell-group>
    </div>
</template>
<script>
import {
    AddYwFeedback,
    YWFbAskedAndReply
} from "@/api/index";
import ckediter4 from "@/components/ck";

export default {
    name: "questionzb",
    components: { ckediter4 },
    data() {
        return {
            uid: Number(this.$store.state.uid),
            fbtype: null,//0,1
            replyUser: [],
            info: {
                ywprojectfile: {},
            },
            editor: null,
            questionDisable: false,
            replayStatus: false, //回复状态
            submitStatus: false, //确认状态
            zwStatus: true, //追问状态
            newFeedback: {},
        }
    },
    computed: {
        replyUserAuthority() {
            return this.replyUser.includes(Number(this.$store.state.uid));
        },
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        getDataShow() {
            if (this.replyUser.includes(Number(this.$store.state.uid)) ===
                true || this.info.creatuser === (Number(this.$store.state.uid))) {
                // 权限
                //状态回复设置
                if (this.info.status === 0) {
                    //
                    this.replayStatus = false;
                    this.questionDisable = false;
                    this.submitStatus = false;
                } else if (this.info.status === 1) {
                    //回复待确认
                    this.replayStatus = true;
                    this.questionDisable = true;
                    this.submitStatus = true;
                    this.zwStatus = true;
                } else if (this.info.status === 2) {
                    //已关闭
                    this.submitStatus = true;
                    this.questionDisable = true;
                    this.replayStatus = false;
                }
            } else {
                this.questionDisable = true;
                this.replayStatus = false;
                // this.submitStatus = true;
            }
        },
        // 追问
        continueBtn(data) {
            this.newFeedback = {
                id: 0,
                feedbackid: this.info.id,
                fbcontent: "",
            };
            this.zwStatus = false;
        },
        // 确认回复
        questionBtn(data, status, index) {
            data.disposecontent = this.$refs.ck[index].editor.getData();
            let result = false;
            this.info.disposelsit.forEach((el) => {
                if (el.disposecontent != null) {
                    // 都不为空
                    result = true;
                } else {
                    // 有空数据
                    this.$Notify({ type: "danger", message: "请填写完成数据!" });
                    result = false;
                }
                return result;
            });
            // result, true为不空,false为空
            if (result != false) {
                let params = {
                    fbid: this.info.id,
                    projectid: this.$store.state.pid,
                    type: this.fbtype,
                    isclose: status,
                    disposeid: data.id,
                    strcontent: !status ? data.disposecontent : '',
                };
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$Notify({ type: "success", message: "操作成功!" });
                        this.replayStatus = true;
                        this.questionDisable = true;
                        this.submitStatus = false;
                        this.$router.go(-1);
                    } else {
                        this.$Notify({ type: "danger", message: res.Message });
                    }
                });
            }
        },
        // 确认回复
        questionBtn1() {
            this.newFeedback.fbcontent = this.$refs.ck2.editor.getData();
            let params = {
                fbid: this.newFeedback.feedbackid,
                projectid: this.$store.state.pid,
                type: this.fbtype,
                isclose: false,
                disposeid: 0,
                strcontent: this.newFeedback.fbcontent,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            YWFbAskedAndReply(fd).then((res) => {
                if (res.Code != 0) {
                    this.$Notify({ type: "success", message: "操作成功!" });
                    this.zwStatus = true;
                    this.$router.go(-1);
                } else {
                    this.$Notify({ type: "danger", message: res.Message });
                }
            });
        },
    },
    mounted() {
        this.info = this.$route.query.item;
        this.replyUser = this.$route.query.item.replayusers.map((i) => i.user01).join('、');
        this.fbtype = this.$route.query.item.type;
        this.getDataShow()
    },
}
</script>
<style lang="scss" scoped>
.questionzb {
    width: 100%;
    height: 100%;
    background: #fff;
}
</style>
